<template>
  <div :class="[baseCss]" v-if="notes.length">
    <collapsible
      padding-off
      :icon-provider="iconProvider"
      :multiple="multiple"
      :bg-color="bgColor"
      :bg-color-lightness="bgColorLightness"
      :bg-color-expanded="bgColorExpanded"
      :bg-color-lightness-expanded="bgColorLightnessExpanded"
      :color="color"
      :color-lightness="colorLightness"
      :color-expanded="colorExpanded"
      :color-lightness-expanded="colorLightnessExpanded">
      <collapsible-item :expanded="isExpanded(index)" :icon="icon" v-for="(item, index) in items" :key="index" :label="item.title">
        <slot name="note" v-bind="item" />
      </collapsible-item>
    </collapsible>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'AppReleaseNotes',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('app-release-notes', [])
    }
  },
  computed: {
    items () {
      const notes = this.notes
      return this.reverse ? notes.reverse() : notes
    }
  },
  props: {
    notes: {
      type: Array,
      default () {
        return []
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'information-outline'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    expand: {
      type: String,
      default: 'none',
      validator: value => {
        return ['all', 'first', 'last', 'none'].includes(value)
      }
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    bgColorExpanded: {
      type: String
    },
    bgColorLightnessExpanded: {
      type: Number
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    colorExpanded: {
      type: String
    },
    colorLightnessExpanded: {
      type: Number
    }
  },
  methods: {
    isExpanded (index) {
      switch (this.expand) {
        case 'first':
          return index === 0
        case 'all':
          return true
        case 'last':
          return index === this.notes.length - 1
        default:
          return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/app-release-notes/app-release-notes.vue